module.exports = __webpack_public_path__ + "webauthn_70x70.24cd830ead20d9573fc421d90f868203.png";